var YTPlayer = {
	players:{},
	playerCount: 0,

	embed: function(node, id, w, h) {
		//setTimeout(function() { YTPlayer.injectPlayer(node, id, w, h); }, 5500);
		var cp = node + "-" + id;
		YTPlayer.players[node + "-" + id] = {"node": node, "id": id, "w": w, "h": h};
		YTPlayer.playerCount ++;
		this.injectPlayer(cp);

		return cp;
	},

	injectPlayer: function(no) {
		var node = YTPlayer.players[no].node;
		var id = YTPlayer.players[no].id;
		var w = YTPlayer.players[no].w;
		var h = YTPlayer.players[no].h;

		var ytp = new YT.Player(node, {
		          height: h,
		          width: w,
		          videoId: id,
		          
		          events: {
					            'onReady': YTPlayer.onPlayerReady,
					            'onStateChange': YTPlayer.onPlayerStateChange
		          }
		});

		YTPlayer.players[no].player = ytp;
	},

	onPlayerReady: function() {

	},

	onPlayerStateChange: function() {

	},

	api: function(no) {
		return YTPlayer.players[no].player;
	},

	each: function(fn) {
		for(var e in YTPlayer.players) {
			fn(YTPlayer.api(e), YTPlayer.players[e]);
		}
	},

	destroy: function(no) {
		YTPlayer.api(no).clearVideo();
		YTPlayer.playerCount --;
		delete YTPlayer.players[no];
	}
}

function onYouTubeIframeAPIReady() {
	AppEvent.on(player, "SOUND.MUTED", function() {
		YTPlayer.each(function(api, pl) {
			if (Volume.yt.muted || Volume.master.muted) api.mute();
		})
	});

	AppEvent.on(player, "VOLUME.SET", function() {
		YTPlayer.each(function(api, pl) {
			if (Volume.currentYTVolume() > 0 && api.setVolume) api.setVolume(Volume.currentYTVolume());
		})
	});

	AppEvent.on(player, "SOUND.UNMUTED", function() {
		YTPlayer.each(function(api, pl) {
			if (!Volume.yt.muted && !Volume.master.muted) api.unMute();
		})		
	});
}